$(function () {
    $.cookie.json = true;
    var cookieParams = {
        expires: 365,
        path: "/"
    };

    $(".add-to-favourites").each(function (i) {
        var id = $(this).data("property-id").toString();
        var cookie = $.cookie("favourite_properties");

        if ($.inArray(id, cookie) >= 0) {
            $(this).removeClass("add-to-favourites").addClass("remove-from-favourites");

            if ($(this).hasClass("text")) {
                $(this).text("Remove from Favourites");
            }
        }
    });

    $("body").on("click", ".add-to-favourites, .remove-from-favourites", function (e) {
        e.preventDefault();
        if ($(this).hasClass("add-to-favourites")) {
            var id = $(this).data("property-id").toString();
            var cookie = $.cookie("favourite_properties");

            if (!cookie) {
                cookie = [id];
            } else {
                if ($.inArray(id, cookie) < 0) {
                    cookie.push(id);
                }
            }

            $.cookie("favourite_properties", cookie, cookieParams);
            $(this).removeClass("add-to-favourites").addClass("remove-from-favourites");
            if ($(this).hasClass("text")) {
                $(this).text("Remove from Favourites");
            }
        } else {
            var id = $(this).data("property-id").toString();;
            var cookie = $.cookie("favourite_properties");

            if (cookie) {
                var i = $.inArray(id, cookie);

                cookie.splice(i, 1);

                $.cookie("favourite_properties", cookie, cookieParams);
            }
            $(this).removeClass("remove-from-favourites").addClass("add-to-favourites");
            if ($(this).hasClass("text")) {
                $(this).text("Add to Favourites");
            }
        }
    });

});